import { useEditClient } from "./useEditClient";
import styles from "./EditClientModal.module.css";

function EditClientModal({ closeModal }) {
  const {
    code,
    name,
    cnpj,
    email,
    phone,
    handleCode,
    handleName,
    handleCnpj,
    handleEmail,
    handlePhone,
    onEditClick,
    isFormValid
  } = useEditClient(closeModal);

  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.content}>
          <form>
            <label>
              <span>Código do Cliente</span>
              <input
                type="text"
                placeholder="Digite o código do cliente"
                value={code}
                onChange={handleCode}
              />
            </label>

            <label>
              <span>Nome do Cliente</span>
              <input
                type="text"
                placeholder="Digite o nome cliente"
                value={name}
                onChange={handleName}
              />
            </label>

            <label>
              <span>CNPJ</span>
              <input
                type="text"
                placeholder="Digite o CNPJ do cliente"
                value={cnpj}
                onChange={handleCnpj}
              />
            </label>

            <label>
              <span>Email</span>
              <input
                type="email"
                placeholder="Digite o email Cliente"
                value={email}
                onChange={handleEmail}
              />
            </label>

            <label>
              <span>Telefone</span>
              <input
                type="text"
                placeholder="Digite o telefone do Cliente"
                value={phone}
                onChange={handlePhone}
              />
            </label>
          </form>
        </div>

        <div className={styles.buttonContent}>
          <button
            onClick={onEditClick}
            className={styles.buttonConfirm}
            disabled={!isFormValid}>
            Editar Cliente
          </button>

          <button
            onClick={closeModal}
            className={styles.buttonCancel}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditClientModal;